import { useAppSelector } from "../store";

export const useAuth = () => {
  const { accessToken, refreshToken } = useAppSelector((state) => state.auth);

  const isAuthenticated = !!accessToken;

  return {
    isAuthenticated,
    accessToken,
    refreshToken,
  };
};
